import React from 'react'
import { Routes, Route, Navigate } from "react-router-dom"
import LandingScorts from './LandingScorts.jsx';
import LandingScortsAdmin from './LandingScortsAdmin.jsx';
import PoliticaCokies from './terminosLegalesZone/PoliticaCokies.jsx';
import PoliticaPrivacidad from './terminosLegalesZone/PoliticaPrivacidad.jsx';
import PoliticaControlParental from './terminosLegalesZone/PoliticaControlParental.jsx';
import DetailScort from './DetailScort.jsx';

function App() {
  return (
    <Routes>
      <Route path="/" exact element={<LandingScorts />} />
      <Route path="adminZone" element={<LandingScortsAdmin />} />
      <Route path="politicaCookies" element={<PoliticaCokies />} />
      <Route path="politicaPrivacidad" element={<PoliticaPrivacidad />} />
      <Route path="controlParental" element={<PoliticaControlParental />} />
      <Route path="detail-scort" element={<DetailScort />} />
      <Route path='*' element={<Navigate to={'/'} replace />} />
    </Routes>
  );
}

export default App;
